import { createTypes } from 'redux-action-creator';

export default createTypes([
  'ADD_PROMISE',
], 'PROMISES');



// WEBPACK FOOTER //
// ./src/app/actions/promises/types.js